/*** IMPORTS FROM imports-loader ***/
var $ = require("jquery");
var jQuery = require("jquery");

export var KEY_PREFIX = 'reduxPersist:';
export var REHYDRATE = 'persist/REHYDRATE';



//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-persist/es/constants.js
// module id = 160
// module chunks = 76